import { useMutation } from '@tanstack/react-query';

import type {
  PostInstructorsRequestsBatchRequest,
  PostInstructorsRequestsBatchResponse,
} from '../../api/post-instructors-requests-batch/postInstructorsRequestsBatch.types';
import type {
  UsePostInstructorsRequestsBatchParams,
  UsePostInstructorsRequestsBatchResult,
} from './usePostInstructorsRequestsBatch.types';

import { postInstructorsRequestsBatch } from '../../api/post-instructors-requests-batch/postInstructorsRequestsBatch';

export function usePostInstructorsRequestsBatch(
  params: UsePostInstructorsRequestsBatchParams
): UsePostInstructorsRequestsBatchResult {
  return useMutation<
    PostInstructorsRequestsBatchResponse,
    Error,
    PostInstructorsRequestsBatchRequest
  >({
    mutationFn: (
      data: PostInstructorsRequestsBatchRequest
    ): Promise<PostInstructorsRequestsBatchResponse> =>
      postInstructorsRequestsBatch(params.customerId, data),
  });
}
